<ul class="schedular-list">
    @for (schedual of cxSchedularService.scheduals; track schedual.id) {
    <li (click)="onRead($event, schedual)">
        <div class="schedular hand">
            <div>
                <span>{{ schedual.name }}</span>
            </div>
            <div class="schedular-action">
                <div class="hour-schedular">
                    <i class="fa-light fa-clock"></i> {{ schedual.cron_label }}
                </div>
                <div>
                    <a (click)="onEdit($event, schedual)"><i class="fa-light fa-edit"></i></a>
                </div>
                <div><a (click)="onDelete($event, schedual)"><i class="fa-light fa-trash"></i></a></div>
            </div>
        </div>
    </li>
    }
</ul>